import React, { useState, useEffect } from "react";
import app from "./firebase";
import Loading from "../components/utilities/loading/loading";
import axios from "axios";
import { Modal, Button, Form } from "react-bootstrap";

export const AuthContext = React.createContext();

export const AuthProvider = ({ children }) => {
    const [currentUser, setCurrentUser] = useState(null);
    const [pending, setPending] = useState(true);
    const [allowEdit, setAllowEdit] = useState(false);
    const [token, setToken] = useState(null);
    const [showNameModal, setShowNameModal] = useState(false);
    const [displayName, setDisplayName] = useState("");

    // Check Firebase auth state
    useEffect(() => {
        app.auth().onAuthStateChanged((user) => {
            setCurrentUser(user);
            setPending(false);
        });
    }, []);

    // After authentication: check if full_name exists in user table


    // Set edit permissions
    useEffect(() => {
        const checkUserType = async () => {
            if (currentUser) {
                const idToken = await app.auth().currentUser.getIdToken(true);
                try {
                    const res = await axios.get(String(process.env.REACT_APP_usertype), {
                        headers: {
                            'Content-Type': 'application/json',
                            'authorization': String(idToken),
                            'Cache-Control': 'no-cache'
                        }
                    });
                    setAllowEdit(res.data.type === "super");
                } catch (err) {
                    console.error("Failed to fetch user type:", err);
                }
            }
        };

        checkUserType();
    }, [currentUser]);



    if (pending) {
        return <Loading />;
    }

    return (
        <AuthContext.Provider value={{ currentUser, allowEdit }}>
            {children}


        </AuthContext.Provider>
    );
};
